import React from 'react'
import routes from 'src/config/routes'
import useWizardManager from '@hooks/useWizardManager'
import { OldPatientPhoneVerificationScreen } from '@screens/OldPatientIdentification/OldPatientPhoneVerificationScreen/OldPatientPhoneVerificationScreen'

export const OldPatientPhoneVerification = () => {
  useWizardManager({
    targetRoute: routes.oldPatientPhoneVerification,
  })

  return <OldPatientPhoneVerificationScreen />
}
